<div class="container">
  <div class="newLogoWrapper" (click)="openMenu()">
    @if (!open) {
      <img src="/assets/svg/logo-icon-new.svg" />
    }
    @if (open) {
      <img src="/assets/svg/logo-white-with-text.svg" />
    }
  </div>

  @if (open) {
    <div class="wrapper">
      <div class="buttonsWrapper">
        <div class="buttons">
          <button icon-button (click)="myProjectsClick()">
            <gl-icon [name]="'file'"></gl-icon>
            <div class="dropdown-trigger-label">
              {{ 'account_my_projects' | translate
              }}<gl-icon
              class="dropdown-trigger-label-icon"
              [class.dropdown-open]="myProjectsClicked"
              [name]="'undo'"
            ></gl-icon>
          </div>
        </button>
        @if (myProjectsClicked) {
          <div class="dropdown" [@height] [glPremium]="true">
            @for (project of projects; track $index) {
              <div
                class="savedProject"
                (click)="openProject(project)"
                >
                <div>
                  <div>
                    {{ project.name | translate }}
                  </div>
                  <div>{{ project.createdAt | date: 'yyyy-MM-dd' }}</div>
                </div>
                <button icon-button>
                  <gl-icon [name]="'export'" class="myProjectIcon"></gl-icon>
                </button>
              </div>
            }
          </div>
        }
        <button icon-button (click)="shareProject()" [disabled]="!isWorkSpace()">
          <gl-icon [name]="'share'"></gl-icon>{{ 'share' | translate }}
        </button>
        <button icon-button id="pdf" (click)="downloadPdf(false)" [disabled]="!isWorkSpace()">
          <gl-icon [name]="'pdf'"></gl-icon>{{ 'pdf' | translate }}
        </button>
        <button
          icon-button
          class="takePhotoButton"
          id="pdf"
          (click)="downloadPdf(true)"
          [disabled]="!isWorkSpace()"
          >
          <gl-icon [name]="'photo'"></gl-icon>{{ 'take_photo' | translate }}
        </button>
        @if (project.workSpaces.length > 0) {
          <button icon-button (click)="loadsListClick()">
            <gl-icon [name]="'cubature'"></gl-icon>
            <div class="dropdown-trigger-label">
              {{ 'load_list' | translate
              }}<gl-icon
              class="dropdown-trigger-label-icon"
              [class.dropdown-open]="loadsListClicked"
              [name]="'undo'"
            ></gl-icon>
          </div>
        </button>
      }
      @if (loadsListClicked) {
        <div class="dropdown" [@height]>
          @if (project.workSpaces.length > 0) {
            <gl-loads-list></gl-loads-list>
          }
        </div>
      }
      @if (project.workSpaces.length > 0) {
        <button
          class="overlapsButton"
          icon-button
          (click)="overlapsLoadingSpacesClick()"
          #openOverlaps
          >
          <gl-icon [name]="'type-truck'"></gl-icon>{{ 'project_summary' | translate }}
        </button>
      }
    </div>
    <div class="buttons">
      <button icon-button (click)="logout()">
        <gl-icon [name]="'profile'"></gl-icon>{{ 'logout' | translate }}
      </button>
    </div>
  </div>
</div>
}
</div>
@if (overlapsLoadingSpacesClicked) {
  <div
    class="overlapsWrapper"
    (glMousedownOutside)="overlapsLoadingSpacesClick()"
    [elementToIgnore]="openOverlapsEl"
    >
    <gl-overlaps-loading-spaces></gl-overlaps-loading-spaces>
  </div>
}
